import { render, staticRenderFns } from "./ParticipantsSearchResults.vue?vue&type=template&id=b70e492e&scoped=true&"
import script from "./ParticipantsSearchResults.vue?vue&type=script&lang=js&"
export * from "./ParticipantsSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantsSearchResults.vue?vue&type=style&index=0&id=b70e492e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70e492e",
  null
  
)

export default component.exports